import { useState, useEffect, useRef } from 'react'
import { recalledStaffPayInFull, rememberStaffPayInFull } from './utils/staffPayInFull';
import { useLocation, useNavigate } from 'react-router-dom';
import StepBackButton from './components/StepBackButton/StepBackButton';
import checkStatus from './jsFunctions/checkStatus.js'

import { grey, green } from '@mui/material/colors';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Box, TextField, InputAdornment, Grid, Radio, FormControlLabel, Checkbox, FormControl, RadioGroup, Typography, Chip, Button, useTheme, useMediaQuery } from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';

import classes from './Reenrolment.module.css'
import Heading from './components/Heading/Heading';
import Paragraph from './components/Paragraph/Paragraph';
import MainTemplate from './components/MainTemplate/MainTemplate';
import ParentDetails from './components/ParentDetails/ParentDetails';
import ButtonWithIcon from './components/ButtonWithIcon/ButtonWithIcon';
import RenrolmentAccordian from './components/RenrolmentAccordian/RenrolmentAccordian';
import TermsandConditions from './components/TermsandConditions/TermsandConditions.js';
import LoadingBackdrop from './components/LoadingBackdrop/LoadingBackdrop.js';

import URL2 from './config.js'
import HCCDiscountForm from './components/reenrolment/HCCDiscountForm.jsx';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import IOSSegmentedControl from './components/common/IOSSegmentedControl';
import { countFeeEligibleChildren, groupChildrenByCampus } from './utils/parentHistoryHelpers.js';
import { currentYear, reenrolmentYear } from './utils/years.js';
import dayjs from 'dayjs';
import {
  HCC_STATUS, earliestExpiry, hccExpiryMessage, hccExpiryState, isHccExpired,
} from './utils/hccExpiry';
import { fetchHccFiles } from './api/cardImages';
import { emptyCardSlots, slotsFromStoredFiles } from './utils/storedCardImages';
import { hccUploadBlocksProgress } from './utils/hccProgress';
import { reenrolmentAnswersFromSaved, parseSavedHccExpiry, formatHccExpiry } from './utils/savedReenrolment';

const Reenrolment = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [showHCCfields, setshowHCCfields] = useState(false);
  const [selectedHCCValue, setSelectedHCCValue] = useState('No');
  const [giveHCCdiscount, setgiveHCCdiscount] = useState(false);

  const [selectedSMValue, setSelectedSMValue] = useState('No');
  const [selectedSDValue, setSelectedSDValue] = useState('No');
  const [selectedEBDValue, setSelectedEBDValue] = useState('No');
  const [selectedMCValue, setSelectedMCValue] = useState('No');
  const [selectedDiscount, setSelectedDiscount] = useState('');
  const [selectedStaffDiscount, setSelectedStaffDiscount] = useState('No');

  const [FTE, setFTE] = useState(0);
  const [SDPER, setSDPER] = useState(0);
  const [EmployeeId, setEmployeeId] = useState(0);

  const [childrens, setchildrens] = useState([]);
  const [enrolledchildrens, setenrolledchildrens] = useState([]);
  const [EmpIDError, setEmpIDError] = useState();
  const [isVerifyingEmployeeId, setIsVerifyingEmployeeId] = useState(false);
  const [ExpiryError, setExpiryError] = useState(false);
  const [disableNext, setdisableNext] = useState(false);
  // Pictures already on file, kept off the form so a later reset of the form cannot drop them.
  const [hccFilesOnRecord, setHccFilesOnRecord] = useState([]);
  const hccFilesRef = useRef([]);
  hccFilesRef.current = hccFilesOnRecord;
  // The card this family already sent, and the expiry it was sent with.
  const [savedHcc, setSavedHcc] = useState({ previouslySent: false, expiry: '' });
  const savedHccRef = useRef(savedHcc);
  savedHccRef.current = savedHcc;
  const [isAgreementChecked, setIsAgreementChecked] = useState(false);
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  //const [college, setCollege] = useState();
  const [famName, setfamName] = useState();
  const [par_email, setpar_email] = useState();
  const [SessionID, setSessionID] = useState();
  const [updatestud_detailsarr, setupdatestud_detailsarr] = useState();
  const [campusSessions, setCampusSessions] = useState([]);
  const [UploadMessage, setUploadMessage] = useState();
  const [Status, SetStatus] = useState();
  const [showEarlyBirdDisc, setshowEarlyBirdDisc] = useState(false);
  const [SchoolFeeArray, setSchoolFeeArray] = useState([]);

  const [parentMultiCollegeDetails, setParentMultiCollegeDetails] = useState([]);

  const currentyear = currentYear();
  const nextyear = reenrolmentYear();


  const location = useLocation();
  let ParentID;
  let credit_amount;
  let isGhostLogin;
  let college;

  if (localStorage.getItem("LoginToken") !== null) {
    ParentID = location.state.ParentID;
    credit_amount = location.state.credit_amount;
    isGhostLogin = location.state.isGhostLogin;
    college = location.state.college;
  }

  const count = useRef(0);

  const typingTimer = useRef();
  const navigate = useNavigate();

  /**
   * The pictures on file that prove the Health Care Card now on screen.
   *
   * A Health Care Card has no number, so its expiry is what identifies it: renew the card and
   * the old picture proves nothing about the new one. Exactly the rule the Medicare card
   * follows.
   */
  const hccSlotsFor = (values = {}) => {
    const expiry = values.hccExpiry ? dayjs(values.hccExpiry).format('YYYY-MM-DD') : '';
    const slots = slotsFromStoredFiles(hccFilesRef.current, { current: { expiry } });
    const cleared = values.hccClearedSlots || [];

    return slots.map((slot, index) => (cleared[index] ? null : slot));
  };

  const initialValues = {
    hccSelections: Array(enrolledchildrens.length).fill('please_select'),
    hccExpiry: '',
    hccImages: [],
    // Which stored pictures the parent has cleared to replace. The files themselves live in
    // state: this form is recreated when the children arrive, and that used to wipe the pictures.
    hccClearedSlots: [],
  }

  const formik = useFormik({
    initialValues: initialValues,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: Yup.object().shape({
      hccSelections: Yup.array()
        .of(Yup.string().oneOf(['yes', 'no'], 'Selection must be "yes" or "no"'))
        .min(enrolledchildrens.length, 'Please select Yes or No for all children'),

      hccExpiry: Yup.date()
        .required('Expiry Date is required')
        .typeError('Invalid date format')
        // Checked here as well as in the picker: a date chosen weeks ago can have passed since,
        // and the picker's minimum only governs what can be clicked today.
        .test(
          'not-expired',
          'This Health Care Card has expired. Please enter the expiry of your current card.',
          (value) => !value || !isHccExpired(value)
        ),

      hccImages: Yup.array().test(
        'both-sides',
        'HCC Front and Back Images are required',
        // A card already uploaded counts. Without this a parent who comes back to this screen —
        // the usual way back is a payment that failed — is asked for a card the school already
        // holds, and then cannot attach one.
        function bothSidesSupplied(value) {
          const onRecord = savedHccRef.current;
          return !hccUploadBlocksProgress({
            chosenFiles: value || [],
            storedSlots: hccSlotsFor(this.parent),
            savedExpiry: onRecord.expiry,
            currentExpiry: this.parent.hccExpiry,
            previouslySent: onRecord.previouslySent,
          });
        }
      ),

    }),
    enableReinitialize: true,
  });

  // Ask what is already uploaded when the screen opens. Nothing did before, so a parent coming
  // back saw two empty boxes and uploaded the same card again.
  useEffect(() => {
    if (!ParentID) return undefined;

    let ignore = false;
    fetchHccFiles(ParentID).then((files) => {
      if (!ignore) setHccFilesOnRecord(files);
    });

    return () => { ignore = true; };
  }, [ParentID]);

  const fetchEarlyBirdDate = async () => {
    setLoading(true);
    try {
      let result = await URL2.post("/fetchEarlyBirdDate");
      const cur_date = new Date();
      if (cur_date < new Date(result.data[0].date)) {
        setshowEarlyBirdDisc(true);
      }
    } catch (error) {
      console.error("Error fetching early bird date:", error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {

    const fetchFunctions = async () => {
      await fetchEarlyBirdDate();
    }

    if (isGhostLogin) {
      fetchFunctions();
      //setCollege(location.state.college);
      setfamName(location.state.famName);
      setchildrens(location.state.childrens);
      setpar_email(location.state.par_email);
      setenrolledchildrens(location.state.enrolledchildrens);
      setSessionID(location.state.SessionID);
      setCampusSessions(location.state.campusSessions || []);

    }

    else if (!isGhostLogin) {
      if (localStorage.getItem("LoginToken") === null) {
        navigate('/');
      }
      else {
        const init = async () => {
          try {
            const data = await checkStatus().catch(err => {
              console.error("An error occurred:", err);
              return null;
            });

            const renrolStatus = data?.RenrolStatus;
            if (renrolStatus !== undefined) {
              SetStatus(renrolStatus);
            }

            // If completed or synced → redirect
            if (renrolStatus === 'Completed' || renrolStatus === 'Synced') {
              navigate('/reenrolmentcompleted', {
                state: {
                  t_date: data?.data?.t_date,
                  t_time: data?.data?.t_time,
                },
              });
              return;
            }

            // Otherwise → fetch & set state
            await fetchFunctions();
            setfamName(location.state.famName);
            setchildrens(location.state.childrens);
            setenrolledchildrens(location.state.enrolledchildrens);
            setpar_email(location.state.par_email);
            setSessionID(location.state.SessionID);
            setCampusSessions(location.state.campusSessions || []);
            count.current = location.state.Collegecount;

          } catch (error) {
            console.error("Unexpected error:", error);
          }
        };

        init();
      }

    }
  }, [ParentID]);
  /**
   * Puts back what the parent already answered here. None of it is compared against TASS — it is
   * restored so they do not answer the same questions again after going back or returning later.
   */
  const [savedAnswersApplied, setSavedAnswersApplied] = useState(false);

  useEffect(() => {
    if (!SessionID || savedAnswersApplied || isGhostLogin) return;

    let ignore = false;

    const applySavedAnswers = async () => {
      try {
        const response = await URL2.get('/fetchSavedReenrolmentDetails', {
          params: { SessionID, ParentID },
        });
        const answers = reenrolmentAnswersFromSaved(response?.data?.Reenrolment);

        if (ignore || !answers) return;

        if (answers.SM) {
          setSelectedSMValue(answers.SM);
          if (answers.SM === 'Yes') setSelectedDiscount('Staff Discount');
        }
        if (answers.EmployeeId) setEmployeeId(answers.EmployeeId);
        if (answers.FTE) setFTE(answers.FTE);
        if (answers.SelectedHCCValue) {
          setSelectedHCCValue(answers.SelectedHCCValue);
          setshowHCCfields(answers.SelectedHCCValue === 'Yes');
        }
        const savedExpiry = parseSavedHccExpiry(answers.HCCExpiryDate);
        if (savedExpiry) {
          const picked = dayjs(savedExpiry);
          formik.setFieldValue('hccExpiry', picked);
          // Re-runs the same checks as picking it by hand, so an expired card is still caught.
          setHCCExpiryDatefunc(picked);
        }
        // Restored before the date, so a card whose date has since passed still shows which
        // children it was for while the parent fixes it.
        if (answers.HccSelections && Object.keys(answers.HccSelections).length) {
          formik.setFieldValue(
            'hccSelections',
            enrolledchildrens.map((child) => answers.HccSelections[child?.stud_code] || 'please_select')
          );
        }
        if (answers.MC) setSelectedMCValue(answers.MC);
        if (answers.SelectedDiscountValue) setSelectedDiscount(answers.SelectedDiscountValue);
        // The Early Bird answer has its own control, and only the discount was being put back: a
        // family who chose Early Bird came back to a "No" while the discount stayed applied, and had
        // to toggle it off and on before the screen and the fees agreed again.
        if (answers.SelectedDiscountValue === 'Early Bird Discount') setSelectedEBDValue('Yes');
        // The staff "pay the whole year now" answer, from the server first.
        //
        // It used to live only in this browser's sessionStorage, so anybody else looking at the same
        // family saw nothing — which is how Zeeshan, signing in through /arlogin to see what parent
        // 17441 was being shown, could not see it. It decides what the family is charged, so it
        // belongs with the other answers.
        //
        // The browser copy is still read, but only as a fallback for a tab that answered the question
        // and has not saved yet. The server wins whenever it has an answer, so two sessions looking at
        // one family agree.
        if (answers.SM === 'Yes') {
          const payInFull = answers.StaffPayInFull || recalledStaffPayInFull(SessionID);
          if (payInFull) {
            setSelectedSDValue(payInFull);
            setSelectedStaffDiscount(payInFull);
          }
        }
        if (answers.hccImagesUploaded) {
          // Remember the card that was sent, not merely that a flag was true. The expiry is what
          // says it is still that card when they come back after a payment fails. Hiding the
          // upload boxes here is what left the parent with nothing to attach and no way on.
          setSavedHcc({
            previouslySent: true,
            expiry: answers.HCCExpiryDate || '',
          });
        }
      } catch (error) {
        // Nothing saved yet, or it could not be read — the page keeps its own defaults.
        console.log(error);
      } finally {
        if (!ignore) setSavedAnswersApplied(true);
      }
    };

    applySavedAnswers();

    return () => { ignore = true; };
  }, [SessionID, savedAnswersApplied, isGhostLogin, ParentID]);

  /** Keeps the answers as they are given, so nothing waits for the fee page. */
  useEffect(() => {
    if (!SessionID || !savedAnswersApplied || isGhostLogin) return;

    const timer = setTimeout(() => {
      URL2.post('/updaterenrolmentdata', {
        SessionID,
        campusSessions,
        SM: selectedSMValue,
        EmployeeId,
        SelectedHCCValue: selectedHCCValue,
        HCCExpiryDate: formatHccExpiry(formik.values.hccExpiry),
        // Which child each answer was for. Without this a parent who came back had to answer for
        // every child again, having already done it. Keyed by student code rather than by
        // position: the children do not necessarily come back in the order they went out.
        HccSelections: enrolledchildrens.reduce((answers, child, index) => {
          const picked = formik.values.hccSelections?.[index];
          if (child?.stud_code && (picked === 'yes' || picked === 'no')) {
            answers[child.stud_code] = picked;
          }
          return answers;
        }, {}),
        MC: selectedMCValue,
        SelectedDiscountValue: selectedDiscount,
        StaffPayInFull: selectedSDValue,
        FTE,
      }).catch((error) => console.log('Could not save re-enrolment answers:', error?.message));
    }, 600);

    return () => clearTimeout(timer);
  }, [
    SessionID, savedAnswersApplied, isGhostLogin, campusSessions,
    selectedSMValue, EmployeeId, selectedHCCValue, formik.values.hccExpiry,
    selectedMCValue, selectedDiscount, FTE,
  ]);

  const handleChange = (event) => {
    setIsAgreementChecked(event.target.checked);
    const familyChildCount = countFeeEligibleChildren(enrolledchildrens);
    if (college !== 'Adelaide' && selectedDiscount === '' && familyChildCount > 2) {
      setSelectedDiscount('Family Discount');
    }
    else if (college === 'Adelaide' && selectedDiscount === '' && familyChildCount > 2) {
      setSelectedDiscount('No Discount');
    }
    else if (selectedDiscount === '' && familyChildCount <= 2) {
      setSelectedDiscount('No Discount');
    }

  };

  const handleSMChange = (event) => {
    setSelectedSMValue(event.target.value);
    if (event.target.value === 'Yes') {
      setSelectedDiscount('Staff Discount')
      setdisableNext(true);
    }
    else if (event.target.value === 'No') {
      setSelectedDiscount('');
      setdisableNext(false);

    }
    setEmpIDError()
  };

  const controlSMProps = (item) => ({
    checked: selectedSMValue === item,
    onChange: handleSMChange,
    value: item,
    name: 'color-radio-button',
    inputProps: { 'aria-label': item },
  });

  const handleSDChange = (event) => {
    setSelectedSDValue(event.target.value);
    rememberStaffPayInFull(SessionID, event.target.value);
    if (event.target.value === 'Yes') {
      setSelectedStaffDiscount('Yes')
    }
    else if (event.target.value === 'No') {
      setSelectedStaffDiscount('No')
    }
    setdisableNext(false);
  };

  const controlSDProps = (item) => ({
    checked: selectedSDValue === item,
    onChange: handleSDChange,
    value: item,
    name: 'color-radio-button',
    inputProps: { 'aria-label': item },
  });


  const handleEBDChange = (event) => {
    setSelectedEBDValue(event.target.value);
    if (event.target.value === 'Yes') {
      setSelectedDiscount('Early Bird Discount');

    }
    else if (event.target.value === 'No') {
      setSelectedDiscount('');

    }
    setdisableNext(false);
  };

  const controlEBDProps = (item) => ({
    checked: selectedEBDValue === item,
    onChange: handleEBDChange,
    value: item,
    name: 'color-radio-button',
    inputProps: { 'aria-label': item },
  });


  const handleHCCChange = (event) => {
    setSelectedHCCValue(event.target.value);
    if (event.target.value === 'Yes') {
      setshowHCCfields(true)
      setSelectedDiscount('Health Care Card Discount');
    }

    else if (event.target.value === 'No') {
      setSelectedDiscount('');
      setdisableNext(false)
      setshowHCCfields(false)
      setExpiryError(false);
      // Reset formik HCC fields when switching to No
      formik.setFieldValue('hccImages', []);
      formik.setFieldValue('hccExpiry', '');
      formik.setFieldValue('hccSelections', Array(enrolledchildrens.length).fill('please_select'));
    }
  };

  const controlHCCProps = (item) => ({
    checked: selectedHCCValue === item,
    onChange: handleHCCChange,
    value: item,
    name: 'color-radio-button',
    inputProps: { 'aria-label': item },
  });

  /**
   * A card that has expired proves nothing, so it is refused. A card that is valid now but runs
   * out before the deadline used to be refused too — it now goes through with a warning, on the
   * assumption that a parent whose card is about to lapse will renew it. Being stopped here left
   * them with no way through the form.
   */
  const setHCCExpiryDatefunc = (value) => {
    const { status } = hccExpiryState(value);

    setgiveHCCdiscount(status === HCC_STATUS.VALID || status === HCC_STATUS.EXPIRING);
    setdisableNext(status === HCC_STATUS.EXPIRED);
    // Kept for the screens that still read it; it now means "expired", not "before the deadline".
    setExpiryError(status === HCC_STATUS.EXPIRED);
  };

  const EmployeeIDChange = (event) => {
    const newEmployeeID = event.target.value;
    clearTimeout(typingTimer.current);

    setEmployeeId(newEmployeeID);
    setEmpIDError();

    if (!newEmployeeID.length) {
      setIsVerifyingEmployeeId(false);
      setdisableNext(true);
      setFTE(0);
      setSDPER(0);
      return;
    }

    setIsVerifyingEmployeeId(true);

    typingTimer.current = setTimeout(async () => {
      if (!/^\d{7}$/.test(newEmployeeID)) {
        setIsVerifyingEmployeeId(false);
        setEmpIDError(true);
        setdisableNext(true);
        setFTE(0);
        setSDPER(0);
        return;
      }

      try {
        const response = await URL2.post("/parent/is-parent-staff", {
          EmployeeID: newEmployeeID,
          ParID: ParentID,
        });

        if (response && response.data) {
          if (response.data.error === "Employee ID not found") {
            setEmpIDError(true);
            setdisableNext(true);
            setFTE(0);
            setSDPER(0);
            return;
          }

          const FTE_Number = (response.data.base_hrs_qty / 76)?.toFixed(2);

          if (FTE_Number > 0) {
            setFTE(FTE_Number);
            setSDPER((50 * FTE_Number).toFixed(2));
            setEmpIDError(false);
            setdisableNext(false);
          } else {
            setEmpIDError(true);
            setdisableNext(true);
            setFTE(0);
            setSDPER(0);
          }
        } else {
          setEmpIDError(true);
          setdisableNext(true);
          setFTE(0);
          setSDPER(0);
        }
      } catch (error) {
        console.error("Employee ID verification failed:", error);
        setEmpIDError(true);
        setdisableNext(true);
        setFTE(0);
        setSDPER(0);
      } finally {
        setIsVerifyingEmployeeId(false);
      }
    }, 1300);
  };

  const UploadMessageFunc = (Message) => {
    setUploadMessage(Message);
  };

  // Handle data passed up from MultipleChildren
  const handleFieldsChange = (newFields) => {
    setChildrenData(newFields); // Store the form data from MultipleChildren
  };
  let HCCImages = [];
  const UploadedHCC = (images) => {
    HCCImages.push(images);
  }

  const navigateToPaymentPage = () => {
    const hccExpiry = new Date(formik.values.hccExpiry.$d);
    const HCCExpiryDate = formik.values.hccExpiry === "" ? "No" : `${hccExpiry.getDate()}-${hccExpiry.getMonth() + 1}-${hccExpiry.getFullYear()}`

    const state = {
      state: {
        DiscountOption: selectedDiscount,
        SM: selectedSMValue,
        SD: selectedStaffDiscount,
        MC: selectedMCValue,
        EmployeeId: EmployeeId,
        SelectedHCCValue: selectedHCCValue,
        HCCExpiryDate: HCCExpiryDate,
        college: college,
        childrens: childrens,
        enrolledchildrens: enrolledchildrens.map((child, index) => (
          {
            ...child,
            HCC: formik?.values?.hccSelections[index] === 'yes'
          }
        )),
        ParentID: ParentID,
        FTE: FTE,
        GiveHCCDiscount: giveHCCdiscount,
        famName: famName,
        updatestud_detailsarr: updatestud_detailsarr,
        SessionID: SessionID,
        campusSessions: campusSessions,
        EmployeeId: EmployeeId,
        UploadMessage: UploadMessage,
        credit_amount: credit_amount,
        isGhostLogin: isGhostLogin,
        earlyBirdAvailable: showEarlyBirdDisc,
      },
    }

    navigate('/payment', state);
  }

  const handleHCCUpload = async () => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('Parent_ID', ParentID);
      formData.append('college', college);
      // Which card these pictures show. Sent the same way it is compared, so the two agree.
      formData.append('hcc_expiry', formik.values.hccExpiry
        ? dayjs(formik.values.hccExpiry).format('YYYY-MM-DD')
        : '');

      const chosen = formik.values.hccImages.filter(Boolean);
      if (chosen.length === 0) {
        // Both sides are already on file and nothing was replaced.
        setLoading(false);
        return;
      }

      formik.values.hccImages.forEach((file, index) => {
        if (!file) return;
        const fileExtension = file.name.split('.').pop();
        const renamedFile = new File([file], `${ParentID}-HCCPicture-${index}.${fileExtension}`);
        formData.append("files", renamedFile);
      });

      if (!isGhostLogin) {
        let response = await URL2.post('/saveHCCpictures', formData,
          {
            headers:
            {
              'Content-Type': 'multipart/form-data', // Set the correct content type for FormData
            },
          });

      }
    } catch (error) {
      console.error("Error uploading HCC pictures:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    setHasSubmitted(true); // Mark as submitted
    const hccSelected = selectedHCCValue === 'Yes';
    const mcSelected = selectedMCValue === 'Yes';

    if (!isGhostLogin) {
      if (hccSelected) {
        // Mark all fields as touched so errors show up
        formik.setTouched({
          hccSelections: formik.values.hccSelections.map(() => true),
          hccExpiry: true,
          hccImages: true,
        }, false); // Don't validate immediately

        // Validate form
        const errors = await formik.validateForm();

        if (Object.keys(errors).length === 0) {
          await handleHCCUpload();
          return navigateToPaymentPage();
        } else {
          formik.setSubmitting(false); // Ensure Formik is not in submitting state
          // Scrolling handled in HCCDiscountForm
        }
      }
      else if (mcSelected) {
        setLoading(true);
        try {
          const response = await URL2.post('/multiplecollegedata', {
            mulcampchildrenData: parentMultiCollegeDetails,
            SessionID,
          });

          if (response.status === 200) {
            return navigateToPaymentPage();
          }
        } catch (error) {
          console.error("Error updating multiple college data:", error);
        } finally {
          setLoading(false);
        }
      } else {
        return navigateToPaymentPage();
      }
    }
  };

  const isMultiCampusFamily =
    groupChildrenByCampus(enrolledchildrens).length > 1 || (campusSessions || []).length > 1;

  // The card already sent, still the one on screen, and not being replaced. That is the case
  // after a failed payment: the pictures are on file, and asking for them again is what stuck.
  const hccOnScreen = hccSlotsFor(formik.values);
  const cardAlreadySent = savedHcc.previouslySent
    && !(formik.values.hccImages || []).some(Boolean)
    && !hccUploadBlocksProgress({
      chosenFiles: [],
      storedSlots: hccOnScreen,
      savedExpiry: savedHcc.expiry,
      currentExpiry: formik.values.hccExpiry,
      previouslySent: true,
    });

  const content = (
    <>
      {/* Back to Parent Information. The answers on this screen are re-read from the server on the way
          back in, so nothing a parent has entered is lost by stepping back to correct a detail. */}
      <Box sx={{ mb: { xs: 1, sm: 1.5 } }}>
          <StepBackButton to="/parentinformation" label="Back" />
      </Box>

      <Box sx={{ mb: 3, textAlign: 'center' }}>
          <Chip
              label="Step 3 of 7"
              size="small"
              sx={{ bgcolor: '#ECFDF5', color: '#065F46', fontWeight: 700, fontSize: '12px', mb: 1, border: '1px solid #A7F3D0' }}
          />
          <Typography variant="h5" component="h1" sx={{ fontWeight: 800, color: '#0F172A', fontSize: { xs: '1.35rem', sm: '1.75rem' }, mb: 0.75 }}>
              Re-enrolment & Discounts
          </Typography>
          <Typography variant="body2" sx={{ color: '#64748B', fontSize: { xs: '13px', sm: '14.5px' }, maxWidth: 640, mx: 'auto' }}>
              Select your re-enrolment intentions and apply for relevant discounts.
          </Typography>
      </Box>

      <ParentDetails
        ParentID={ParentID}
        college={college}
        famName={famName}
        childrens={childrens}
      />

      <Grid container mt={0} spacing={4} sx={{ display: 'flex', flexDirection: 'column', margin: '0px', width: '100%' }}>

        {(selectedEBDValue === 'No' && selectedHCCValue === 'No') && (
          <Grid item md={12} xs={12} sx={{ 
            backgroundColor: '#F8FAFC',
            border: "1px solid #E2E8F0", 
            borderRadius: "12px", 
            p: { xs: 2, sm: 3 }, 
            mb: 1, 
            mt: 2 
          }}>
            <Box sx={{ 
              display: 'flex', 
              alignItems: 'baseline', 
              flexDirection: 'column',
              mb: { xs: 2, sm: 1 }
            }}>
              <Typography 
                component="h6" 
                mt={'0'} 
                sx={{ 
                  color: "#242424", 
                  fontSize: { xs: '13px', sm: '14px' },
                  mb: { xs: 1.5, sm: 1 },
                  lineHeight: 1.4
                }}
              >
                Are you a staff member?
              </Typography>
              <Box sx={{ width: '100%', maxWidth: { xs: '100%', sm: '220px' } }}>
                <IOSSegmentedControl
                    options={[{ label: 'YES', value: 'Yes' }, { label: 'NO', value: 'No' }]}
                    value={selectedSMValue}
                    onChange={(val) => handleSMChange({ target: { value: val } })}
                    disabled={selectedMCValue === 'Yes'}
                />
              </Box>
            </Box>
            {selectedSMValue === "Yes" &&
              <Box sx={{ 
                width: '100%',
                maxWidth: { xs: '100%', sm: '350px' },
                mt: { xs: 2, sm: 1 }
              }}>
                <TextField
                  label="Employee ID"
                  type="text"
                  size="small"
                  variant="outlined"
                  fullWidth
                  FormHelperTextProps={{ 
                    style: { 
                      color: EmpIDError === true ? 'red' : EmpIDError === false ? 'green' : 'inherit', 
                      marginLeft: '2px', 
                      fontSize: { xs: '12px', sm: '14px' }, 
                      fontStyle: EmpIDError === true ? 'italic' : 'normal', 
                      fontWeight: EmpIDError === false ? 500 : 'normal',
                      lineHeight: 1.3,
                      marginTop: '4px',
                      whiteSpace: 'normal',
                      wordWrap: 'break-word'
                    } 
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {isVerifyingEmployeeId && (
                          <CircularProgress size={18} sx={{ color: '#059669' }} />
                        )}
                        {!isVerifyingEmployeeId && EmpIDError === false && (
                          <DoneIcon color="success" fontSize={'small'} />
                        )}
                        {!isVerifyingEmployeeId && EmpIDError === true && (
                          <CloseIcon color="error" fontSize={'small'} />
                        )}
                      </InputAdornment>
                    ),
                  }}
                  sx={
                    [
                      {
                        bgcolor: 'white',
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '8px',
                        },
                        '& .MuiSvgIcon-fontSizeSmall': {
                          position: 'relative',
                          top: '-3px'
                        },
                        '& input': {
                          fontSize: { xs: '13px', sm: '14px' }
                        },
                        '& .MuiFormHelperText-root': {
                          fontSize: { xs: '11px', sm: '12px' },
                          lineHeight: 1.3,
                          marginTop: '6px'
                        }
                      },
                      EmpIDError === true && {
                        '& .MuiOutlinedInput-root': {
                          '& fieldset': {
                            borderColor: 'red',
                          },
                          '&:hover fieldset': {
                            borderColor: 'red',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: 'red',
                          }
                        }
                      },
                      EmpIDError === false && {
                        '& .MuiOutlinedInput-root': {
                          '& fieldset': {
                            borderColor: 'green',
                          },
                          '&:hover fieldset': {
                            borderColor: 'green',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: 'green',
                          }
                        }
                      },
                    ]
                  }
                  onChange={EmployeeIDChange}
                  helperText={
                    isVerifyingEmployeeId
                      ? 'Checking employee ID…'
                      : EmpIDError === true
                        ? "Your employee code could not be verified. Please contact the Accounts Receivable team for further assistance."
                        : EmpIDError === false
                          ? 'Your employee code has been successfully verified.'
                          : ''
                  }
                />
              </Box>
            }

            {
              (selectedSMValue === "Yes" && EmpIDError === false) &&
              <Box sx={{ 
                display: 'flex', 
                alignItems: 'baseline', 
                flexDirection: 'column',
                mt: { xs: 3, sm: 2 },
                mb: { xs: 2, sm: 1 }
              }}>
                <Typography 
                  component="h6" 
                  sx={{ 
                    color: "#242424", 
                    fontSize: { xs: '13px', sm: '14px' },
                    lineHeight: { xs: 1.4, sm: 1.3 },
                    mb: { xs: 2, sm: 1.5 },
                    wordBreak: 'break-word',
                    hyphens: 'auto'
                  }}
                >
                  {`Would you like to pay the whole year fee and avail staff discount right now?`}
                </Typography>
                <Box sx={{ width: '100%', maxWidth: { xs: '100%', sm: '220px' } }}>
                  <IOSSegmentedControl
                      options={[{ label: 'YES', value: 'Yes' }, { label: 'NO', value: 'No' }]}
                      value={selectedSDValue}
                      onChange={(val) => handleSDChange({ target: { value: val } })}
                      disabled={selectedMCValue === 'Yes'}
                  />
                </Box>
              </Box>
            }

            {(EmpIDError === false && selectedStaffDiscount === 'Yes') &&
              <Box sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                mt: { xs: 2, sm: 1.5 },
                mb: { xs: 2, sm: 1 },
                p: { xs: 2, sm: 1.5 },
                backgroundColor: '#f0f8f0',
                borderRadius: '8px',
                border: '1px solid #c8e6c9'
              }}>
                <Paragraph 
                  margin={'0'} 
                  color={'#2e7d32'} 
                  fontSize={{ xs: '12px', sm: '13px' }} 
                  text={`You are qualified to apply for staff discounts. Please pay the total Resource Fee and School Fee in the next step.`} 
                />
              </Box>
            }
            
            {(EmpIDError === false && selectedSMValue === 'Yes') &&
              <Box sx={{
                marginTop: '20px',
                padding: { xs: '12px', sm: '16px' },
                backgroundColor: '#f8f9fa',
                borderRadius: '8px',
                border: '1px solid #dee2e6'
              }}>
                <Typography 
                  component="h6" 
                  sx={{ 
                    color: "#242424", 
                    fontSize: { xs: '12px', sm: '13px', md: '14px' }, 
                    fontWeight: 'bold',
                    marginBottom: { xs: '10px', sm: '12px' },
                    lineHeight: 1.4
                  }}
                >
                  {`Please indicate below how the ${nextyear} fees will be paid (staff discount % will be pro-rated for part-time staff):`}
                </Typography>
                
                <Box sx={{ 
                  display: 'flex', 
                  flexDirection: 'column', 
                  gap: { xs: '6px', sm: '8px', md: '10px' }
                }}>
                  <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: { xs: 'flex-start', sm: 'center' },
                    flexDirection: { xs: 'column', sm: 'row' },
                    flexWrap: 'wrap',
                    gap: { xs: '4px', sm: '8px' },
                    paddingBottom: { xs: '8px', sm: '0px' },
                    borderBottom: { xs: '1px solid #eee', sm: 'none' }
                  }}>
                    <Typography sx={{ 
                      fontSize: { xs: '10px', sm: '11px', md: '13px' }, 
                      color: '#333',
                      fontWeight: 'bold',
                      flex: { xs: '1 1 100%', sm: '1 1 auto' },
                      marginBottom: { xs: '2px', sm: '0px' }
                    }}>
                      {`Full payment before 30 November ${currentyear}`}
                    </Typography>
                    <Typography sx={{ 
                      fontSize: { xs: '10px', sm: '11px', md: '13px' }, 
                      color: '#246c34', 
                      fontWeight: 'bold',
                      textAlign: { xs: 'left', sm: 'right' },
                      flex: { xs: '1 1 100%', sm: '0 0 auto' }
                    }}>
                      50% Staff Discount
                    </Typography>
                  </Box>
                  
                  <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: { xs: 'flex-start', sm: 'center' },
                    flexDirection: { xs: 'column', sm: 'row' },
                    flexWrap: 'wrap',
                    gap: { xs: '4px', sm: '8px' },
                    paddingBottom: { xs: '8px', sm: '0px' },
                    borderBottom: { xs: '1px solid #eee', sm: 'none' }
                  }}>
                    <Typography sx={{ 
                      fontSize: { xs: '10px', sm: '11px', md: '13px' }, 
                      color: '#333',
                      fontWeight: 'bold',
                      flex: { xs: '1 1 100%', sm: '1 1 auto' },
                      marginBottom: { xs: '2px', sm: '0px' }
                    }}>
                      {`Salary Deduction (Ending by 15 December ${currentyear})`}
                    </Typography>
                    <Typography sx={{ 
                      fontSize: { xs: '10px', sm: '11px', md: '13px' }, 
                      color: '#246c34', 
                      fontWeight: 'bold',
                      textAlign: { xs: 'left', sm: 'right' },
                      flex: { xs: '1 1 100%', sm: '0 0 auto' }
                    }}>
                      50% Staff Discount
                    </Typography>
                  </Box>
                  
                  <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: { xs: 'flex-start', sm: 'center' },
                    flexDirection: { xs: 'column', sm: 'row' },
                    flexWrap: 'wrap',
                    gap: { xs: '4px', sm: '8px' },
                    paddingBottom: { xs: '8px', sm: '0px' },
                    borderBottom: { xs: '1px solid #eee', sm: 'none' }
                  }}>
                    <Typography sx={{ 
                      fontSize: { xs: '10px', sm: '11px', md: '13px' }, 
                      color: '#333',
                      fontWeight: 'bold',
                      flex: { xs: '1 1 100%', sm: '1 1 auto' },
                      marginBottom: { xs: '2px', sm: '0px' }
                    }}>
                      Per Term (due no later than Week 2 of each term)
                    </Typography>
                    <Typography sx={{ 
                      fontSize: { xs: '10px', sm: '11px', md: '13px' }, 
                      color: '#246c34', 
                      fontWeight: 'bold',
                      textAlign: { xs: 'left', sm: 'right' },
                      flex: { xs: '1 1 100%', sm: '0 0 auto' }
                    }}>
                      30% Staff Discount (pro-rated for part-time staff)
                    </Typography>
                  </Box>
                  
                  <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: { xs: 'flex-start', sm: 'center' },
                    flexDirection: { xs: 'column', sm: 'row' },
                    flexWrap: 'wrap',
                    gap: { xs: '4px', sm: '8px' },
                    paddingBottom: { xs: '8px', sm: '0px' },
                    borderBottom: { xs: '1px solid #eee', sm: 'none' }
                  }}>
                    <Typography sx={{ 
                      fontSize: { xs: '10px', sm: '11px', md: '13px' }, 
                      color: '#333',
                      fontWeight: 'bold',
                      flex: { xs: '1 1 100%', sm: '1 1 auto' },
                      marginBottom: { xs: '2px', sm: '0px' }
                    }}>
                      Per Month / Fortnight
                    </Typography>
                    <Typography sx={{ 
                      fontSize: { xs: '10px', sm: '11px', md: '13px' }, 
                      color: '#246c34', 
                      fontWeight: 'bold',
                      textAlign: { xs: 'left', sm: 'right' },
                      flex: { xs: '1 1 100%', sm: '0 0 auto' },
                      wordBreak: { xs: 'break-word', sm: 'normal' }
                    }}>
                      20% Staff Discount (pro-rated for part-time staff)
                    </Typography>
                  </Box>
                  
                  <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: { xs: 'flex-start', sm: 'center' },
                    flexDirection: { xs: 'column', sm: 'row' },
                    flexWrap: 'wrap',
                    gap: { xs: '4px', sm: '8px' },
                    paddingBottom: { xs: '8px', sm: '0px' },
                    borderBottom: { xs: '1px solid #eee', sm: 'none' }
                  }}>
                    <Typography sx={{ 
                      fontSize: { xs: '10px', sm: '11px', md: '13px' }, 
                      color: '#333',
                      fontWeight: 'bold',
                      flex: { xs: '1 1 100%', sm: '1 1 auto' },
                      marginBottom: { xs: '2px', sm: '0px' }
                    }}>
                      {`Salary Deduction (Continuing beyond 15 December ${currentyear})`}
                    </Typography>
                    <Typography sx={{ 
                      fontSize: { xs: '10px', sm: '11px', md: '13px' }, 
                      color: '#246c34', 
                      fontWeight: 'bold',
                      textAlign: { xs: 'left', sm: 'right' },
                      flex: { xs: '1 1 100%', sm: '0 0 auto' },
                      wordBreak: { xs: 'break-word', sm: 'normal' }
                    }}>
                      20% Staff Discount (pro-rated for part-time staff)
                    </Typography>
                  </Box>
                </Box>
              </Box>
            }
          </Grid>
        )}

        {(selectedSMValue === 'No' && selectedHCCValue === 'No' && showEarlyBirdDisc) && (
          <Grid item md={12} xs={12} sx={{ backgroundColor: '#F8FAFC', border: "1px solid #E2E8F0", borderRadius: "12px", p: 3, mb: 1, mt: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'baseline', flexDirection: 'column' }}>
              <Typography component="h6" mt={'0'} sx={{ color: "#242424", textAlign: 'left', fontSize: '14px', mb: 1.5 }}>{"Would you like to pay the total amount right now and avail a 5% Early Bird Discount?"}</Typography>
              <Box sx={{ width: '100%', maxWidth: { xs: '100%', sm: '220px' } }}>
                <IOSSegmentedControl
                    options={[{ label: 'YES', value: 'Yes' }, { label: 'NO', value: 'No' }]}
                    value={selectedEBDValue}
                    onChange={(val) => handleEBDChange({ target: { value: val } })}
                    disabled={selectedMCValue === 'Yes'}
                />
              </Box>
            </Box>
            {selectedEBDValue === "Yes" &&
              <Box sx={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                <strong><Paragraph margin={'0 10px 0 0'} color={'black'} fontSize={'13px'} text={`You are qualified to apply for a 5% discount. Please pay the total Resource Fee and School Fee in the next step.`} /></strong>
              </Box>
            }
          </Grid>
        )}

        {(selectedSMValue === 'No' && isMultiCampusFamily && selectedEBDValue !== 'Yes') && (
          <Grid item md={12} xs={12} sx={{ backgroundColor: '#F8FAFC', border: "1px solid #E2E8F0", borderRadius: "12px", p: 3, mb: 1, mt: 2 }}>
            <Typography component="h6" mt={'0'} sx={{ color: "#242424", textAlign: 'left', fontSize: '14px', mb: 1 }}>
              Payment options for each campus
            </Typography>
            <Typography sx={{ color: '#334155', fontSize: '13px', lineHeight: 1.6 }}>
              On the next page you can choose, for each campus:
            </Typography>
            <Box component="ul" sx={{ m: '8px 0 0', pl: 2.5, color: '#334155', fontSize: '13px', lineHeight: 1.7 }}>
              <li>
                <strong>Pay the minimum required for re-enrolment</strong>
                {` — keep the 5% Health Care Card discount on school fees if you are eligible, and pay only the deposit and resource fees required now.`}
              </li>
              <li>
                <strong>Pay the full amount</strong>
                {` — pay this campus’s full fees now. Any discount you selected above still applies.`}
              </li>
            </Box>
          </Grid>
        )}

        {(selectedEBDValue === 'No' && selectedSMValue === 'No') && (
          <Grid item md={12} xs={12} sx={{ backgroundColor: '#F8FAFC', border: "1px solid #E2E8F0", borderRadius: "12px", p: 3, mb: 1, mt: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'baseline', flexDirection: 'column' }}>
              <Typography component="h6" mt={'0'} sx={{ color: "#242424", fontSize: '14px', mb: 1.5 }}>{'Do you have a Health Care Card?'}</Typography>
              <Box sx={{ width: '100%', maxWidth: { xs: '100%', sm: '220px' } }}>
                <IOSSegmentedControl
                    options={[{ label: 'YES', value: 'Yes' }, { label: 'NO', value: 'No' }]}
                    value={selectedHCCValue}
                    onChange={(val) => handleHCCChange({ target: { value: val } })}
                    disabled={selectedMCValue === 'Yes'}
                />
              </Box>
            </Box>

            {showHCCfields &&
              <HCCDiscountForm
                showHCCfields={showHCCfields}
                enrolledchildrens={enrolledchildrens}
                ExpiryError={ExpiryError}
                expiryMessage={hccExpiryMessage(formik.values.hccExpiry, { college })}
                minExpiry={earliestExpiry()}
                college={college}
                cardAlreadySent={cardAlreadySent}
                isGhostLogin={isGhostLogin}
                UploadedHCC={UploadedHCC}
                UploadMessageFunc={UploadMessageFunc}
                ParentID={ParentID}
                setHCCExpiryDatefunc={setHCCExpiryDatefunc}
                formik={formik}
                hasSubmitted={hasSubmitted}
                storedUrls={hccSlotsFor(formik.values)}
                onRemoveStored={(index) => {
                  const cleared = [...(formik.values.hccClearedSlots || emptyCardSlots())];
                  cleared[index] = true;
                  formik.setFieldValue('hccClearedSlots', cleared);
                }}
              />
            }
          </Grid>
        )}

        <Grid item md={12} xs={12} sx={{ mb: 2 }}>
          {selectedSMValue === 'Yes' ? (
            <Box sx={{ p: 2, borderRadius: '12px', bgcolor: '#f3e8ff', border: '1px solid #d8b4fe', display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
              <Typography sx={{ color: '#9333ea', mt: 0.25 }}><i className="fa-solid fa-user-check"></i></Typography>
              <Typography sx={{ color: '#4c1d95', fontSize: '12px' }}>
                <strong>Staff Member Selected:</strong> {`Staff discount applies to School Fees. To retain full benefit for ${nextyear}, employment must remain active for the full calendar year.`}
              </Typography>
            </Box>
          ) : selectedHCCValue === 'Yes' ? (
            <Box sx={{ p: 2, borderRadius: '12px', bgcolor: '#fef3c7', border: '1px solid #fcd34d', display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
              <Typography sx={{ color: '#d97706', mt: 0.25 }}><i className="fa-solid fa-circle-exclamation"></i></Typography>
              <Typography sx={{ color: '#92400e', fontSize: '12px' }}>
                <strong>Health Care Card Concession:</strong> {`Ensure your card is valid for ${nextyear} to receive the 5% discount on school fees. Note: HCC discount recipients are not eligible for the 5% Early Bird Discount.`}
                {(isMultiCampusFamily)
                  ? ' You can still choose to pay the minimum or the full amount for each campus on the next page.'
                  : ''}
              </Typography>
            </Box>
          ) : selectedEBDValue === 'Yes' ? (
            <Box sx={{ p: 2, borderRadius: '12px', bgcolor: '#ecfdf5', border: '1px solid #6ee7b7', display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
              <Typography sx={{ color: '#059669', mt: 0.25 }}><i className="fa-solid fa-circle-check"></i></Typography>
              <Typography sx={{ color: '#064e3b', fontSize: '12px' }}>
                🎉 <strong>5% Early Bird Discount Locked In!</strong> Your saving is applied to the fees shown on the payment page. Full payment (including Resource Fees) must be processed prior to 30 November.
              </Typography>
            </Box>
          ) : (
            <Box sx={{ p: 2, borderRadius: '12px', bgcolor: '#eff6ff', border: '1px solid #bfdbfe', display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
              <Typography sx={{ color: '#2563eb', mt: 0.25 }}><i className="fa-solid fa-lightbulb"></i></Typography>
              <Typography sx={{ color: '#1e3a8a', fontSize: '12px' }}>
                💡 <strong>Savings Tip:</strong> {`A 5% discount on school fees is available if the full-year school fees are paid before 30 November ${currentyear}. Alternatively, you can select ‘Yes’ now and pay the full-year school fee now to receive the 5% school fee discount instantly.`}
              </Typography>
            </Box>
          )}
        </Grid>

        <TermsandConditions />

        {/* Desktop Action Area */}
        {!isMobile && (
          <Box
            sx={{
              mt: 3,
              pt: 2,
              borderTop: '1px solid #E2E8F0',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}
          >
            <FormControlLabel
              required
              control={
                <Checkbox
                  checked={isAgreementChecked}
                  onChange={handleChange}
                  sx={{
                    padding: '0px 8px 0px 8px',
                    '&.Mui-checked': {
                      color: green[900],
                    },
                  }}
                />
              }
              label={
                <Typography component="span" sx={{ fontSize: '14px', fontWeight: 600, color: '#334155' }}>
                  I have read and understood the Terms and Conditions
                </Typography>
              }
            />
            <Button
                variant="contained"
                size="large"
                endIcon={<NavigateNextIcon />}
                disabled={EmpIDError === true || disableNext || !isAgreementChecked}
                onClick={async () => { await handleSubmit() }}
                sx={{
                    bgcolor: '#059669',
                    color: '#FFFFFF',
                    fontWeight: 700,
                    px: 4,
                    py: 1.5,
                    borderRadius: '12px',
                    textTransform: 'none',
                    fontSize: '16px',
                    boxShadow: '0 4px 14px rgba(5, 150, 105, 0.35)',
                    '&:hover': {
                        bgcolor: '#047857',
                        boxShadow: '0 6px 20px rgba(5, 150, 105, 0.45)',
                    },
                    '&.Mui-disabled': {
                        bgcolor: '#94a3b8',
                        color: '#f1f5f9',
                        boxShadow: 'none'
                    }
                }}
            >
                Next Page
            </Button>
          </Box>
        )}

        {/* Mobile Sticky Glassmorphism Action Bar */}
        {isMobile && (
            <Box
                sx={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    px: 2,
                    py: 1.5,
                    bgcolor: 'rgba(255, 255, 255, 0.94)',
                    backdropFilter: 'blur(16px)',
                    borderTop: '1px solid rgba(226, 232, 240, 0.9)',
                    boxShadow: '0 -4px 20px rgba(0, 0, 0, 0.08)',
                    zIndex: 1100,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 1
                }}
            >
                <FormControlLabel
                  required
                  control={
                    <Checkbox
                      size="small"
                      checked={isAgreementChecked}
                      onChange={handleChange}
                      sx={{
                        padding: '0px 8px 0px 8px',
                        '&.Mui-checked': {
                          color: green[900],
                        },
                      }}
                    />
                  }
                  label={
                    <Typography component="span" sx={{ fontSize: '11px', fontWeight: 600, color: '#334155', lineHeight: 1.2 }}>
                      I accept the Terms and Conditions
                    </Typography>
                  }
                  sx={{ m: 0 }}
                />
                <Button
                    variant="contained"
                    size="large"
                    endIcon={<NavigateNextIcon />}
                    disabled={EmpIDError === true || disableNext || !isAgreementChecked}
                    onClick={async () => { await handleSubmit() }}
                    sx={{
                        bgcolor: '#059669',
                        color: '#FFFFFF',
                        fontWeight: 700,
                        px: 2,
                        py: 1.25,
                        borderRadius: '12px',
                        textTransform: 'none',
                        fontSize: '14px',
                        minHeight: '48px', // iOS 48px touch target
                        boxShadow: '0 4px 14px rgba(5, 150, 105, 0.35)',
                        '&:hover': {
                            bgcolor: '#047857',
                        },
                        '&.Mui-disabled': {
                            bgcolor: '#94a3b8',
                            color: '#f1f5f9',
                            boxShadow: 'none'
                        },
                        flexShrink: 0
                    }}
                >
                    Next
                </Button>
            </Box>
        )}
      </Grid>
    </>
  );

  return (
    <>
      <LoadingBackdrop open={loading} icon={<CircularProgress sx={{ color: '#fff' }} />} />
      <MainTemplate college={`${college}`} content={content} SessionID={SessionID} />
    </>
  )
}

export default Reenrolment
